webpackJsonp([3],{

/***/ 671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeedPanel_vue__ = __webpack_require__(682);
/* empty harmony namespace reexport */
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeedPanel_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 676:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_steem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_steem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_steem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_remarkable__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_remarkable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_remarkable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_scroll__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_infinite_scroll__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // 스팀잇 라이브러리 임포트


// import { mapState, mapGetters } from 'vuex'

var md = new __WEBPACK_IMPORTED_MODULE_1_remarkable___default.a({ html: true, linkify: true });

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Discussions',
  data: function data() {
    return {
      discussions: [],
      busy: false,
      next: {
        exist: true,
        permlink: null,
        author: null
      }
    };
  },
  computed: {
    // isLogin () {
    //   return this.$store.getters['auth/isLogin']
    // },
    // ...mapGetters('auth', [ 'isLogin' ]),
    // ...mapState('auth', [ 'username' ]),
    UserProfilePanel: function UserProfilePanel() {
      // console.log('isLogin:', this.$store.getters['auth/isLogin'])
      // if (this.isLogin) {
      if (this.$store.getters['auth/isLogin']) {
        return function () {
          return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 670));
        };
      } else {
        return function () {
          return '';
        };
      }
    },
    type: function type() {
      return this.$route;
    }
  },
  // components: {
  //   UserProfilePanel: () => {
  //     console.log('this.isLogin:', this.isLogin)
  //     if (this.isLogin) {
  //       return import('@/components/panels/UserProfilePanel')
  //     } else {
  //       return ''
  //     }
  //   }
  // },
  directives: {
    infiniteScroll: __WEBPACK_IMPORTED_MODULE_2_vue_infinite_scroll___default.a
  },
  // watch: {
  //   '$route' (to, from) {
  //     console.log('to:', to, '\nfrom:', from)
  //     getDiscussions()
  //   }
  // },
  methods: {
    loadMore: function loadMore() {
      var _this = this;

      this.busy = true;
      // this.$refs.infiniteScroll.$el.scrollTop = this.$refs.infiniteScroll.$el.scrollHeight
      this.getDiscussions().then(function (result) {
        // 가져온 데이터를 items 에 담는다.
        var items = result.slice(0, 10).map(function (item) {
          var metadata = JSON.parse(item.json_metadata); // 메타데이터 JSON 파싱
          var image = metadata.image ? metadata.image[0] : ''; // 이미지 URL

          var totalPayoutValue = parseFloat(item.total_payout_value.split(' ')[0]);
          var curatorPayoutValue = parseFloat(item.curator_payout_value.split(' ')[0]);
          var pendingPayoutCalue = parseFloat(item.pending_payout_value.split(' ')[0]);
          item.payout_value = (totalPayoutValue + curatorPayoutValue + pendingPayoutCalue).toFixed(2);

          item.author_reputation = __WEBPACK_IMPORTED_MODULE_0_steem___default.a.formatter.reputation(item.author_reputation); // 저자 명성

          item.created = item.created;

          item.body = md.render(item.body).replace(/<\/?[^>]+(>|$)/g, '');

          return {
            id: item.id,
            image: image,
            author: item.author,
            author_reputation: item.author_reputation,
            title: item.title,
            created: item.created,
            body: item.body.substr(0, 200),
            category: item.category,
            permlink: item.permlink,
            url: item.url,
            payout_value: item.payout_value,
            net_votes: item.net_votes,
            children: item.children
          };
        });

        // items배열을 기존 discussions 배열과 합친다.
        _this.discussions = _this.discussions.concat(items);

        _this.next.exist = result.length > 10;
        // 스크롤 활성화
        if (_this.next.exist) {
          _this.next.permlink = result[10].permlink;
          _this.next.author = result[10].author;
          _this.busy = false;
        }
      }).catch(function (err) {
        return console.log(err);
      });
      // window.scrollTo(0, document.body.scrollHeight)
      // var scrollingElement = (document.scrollingElement || document.body)
      // scrollingElement.scrollTop = scrollingElement.scrollHeight
      // scrollingElement.scrollIntoView(false)
      // scrollingElement.scrollIntoView({ behavior: 'smooth' })
      // scrollingElement.animate({ scrollTop: scrollingElement.scrollHeight }, 'slow')
    },
    getDiscussions: function getDiscussions() {
      // steem.api.getDiscussionsByBlog(
      // await steem.api.getDiscussionsByFeedAsync({tag:'anpigon', limit: 11})
      // steem.api.getDiscussionsByHot(
      // steem.api.getDiscussionsByPayout(
      // steem.api.getDiscussionsByCashout(
      // steem.api.getDiscussionsByTrending(
      var query = {
        tag: 'kr',
        limit: 11,
        start_permlink: this.next.permlink,
        start_author: this.next.author
        // 스팀잇 최근글 가져오기
      };return __WEBPACK_IMPORTED_MODULE_0_steem___default.a.api.getDiscussionsByCreatedAsync(query);
    }
  },
  created: function created() {
    // this.getDiscussions()
    // console.log('isLogin', this.isLogin)
    // this.$store.dispatch('global/loadGlobalProperties')
    console.log('Main.vue created => type:', this.type);
  },
  deactivated: function deactivated() {
    this.busy = true;
  },
  activated: function activated() {
    this.busy = false;
    // console.log('username', this.$store.state.auth.username)
  }
});

/***/ }),

/***/ 677:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Discussions_vue__ = __webpack_require__(676);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90df1f94_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Discussions_vue__ = __webpack_require__(680);
function injectStyle (ssrContext) {
  __webpack_require__(678)
}
var normalizeComponent = __webpack_require__(25)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-90df1f94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Discussions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90df1f94_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Discussions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(679);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(669)("0805081e", content, true, {});

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(668)(true);
// imports


// module
exports.push([module.i, ".text-ellipsis[data-v-90df1f94]{overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:3;display:-moz-box;display:-webkit-box;display:box;\r\n  /*! autoprefixer: off */-moz-box-orient:vertical;-webkit-box-orient:vertical;box-orient:vertical \r\n  /*! autoprefixer: on */}.bottom[data-v-90df1f94]{min-height:10px;display:block}@media only screen and (max-width:1263px){.v-content__wrap>.container.fill-height[data-v-90df1f94]{max-width:100%}}", "", {"version":3,"sources":["C:/workspace/steemit-app/src/components/panels/Discussions.vue"],"names":[],"mappings":"AACA,gCACE,gBAAiB,AACjB,uBAAwB,AACxB,qBAAsB,AACtB,iBAAkB,AAClB,oBAAqB,AACrB,YAAa;EACb,wBAAwB,AACxB,yBAA0B,AAC1B,4BAA6B,AAC7B,mBAAqB;EACrB,uBAAuB,CACxB,AACD,yBACE,gBAAiB,AACjB,aAAe,CAChB,AACD,0CACA,yDACI,cAAgB,CACnB,CACA","file":"Discussions.vue","sourcesContent":["\n.text-ellipsis[data-v-90df1f94] {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  -webkit-line-clamp: 3;\r\n  display: -moz-box;                /* Mozilla */\r\n  display: -webkit-box;             /* WebKit */\r\n  display: box;                     /* As specified */\r\n  /*! autoprefixer: off */\r\n  -moz-box-orient: vertical;      /* Mozilla */\r\n  -webkit-box-orient: vertical;   /* WebKit */\r\n  box-orient: vertical;           /* As specified */ \r\n  /*! autoprefixer: on */\n}\n.bottom[data-v-90df1f94] {\r\n  min-height: 10px;\r\n  display: block;\n}\n@media only screen and (max-width: 1263px) {\n.v-content__wrap >  .container.fill-height[data-v-90df1f94] {\r\n    max-width: 100%;\n}\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 680:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.loadMore),expression:"loadMore"}],attrs:{"infinite-scroll-disabled":"busy","infinite-scroll-distance":"30"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.discussions),function(d){return _c('v-flex',{key:d.id,attrs:{"xs12":"","md6":"","xl4":""}},[_c('v-card',[_c('v-list',[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":'https://steemitimages.com/u/' + d.author + '/avatar/small',"alt":"avatar","onerror":"this.src='https://steemitimages.com/u/monawoo/avatar/small'"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(d.author)+" "),_c('span',{staticClass:"reputation"},[_vm._v("("+_vm._s(d.author_reputation)+")")])]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("filterCreated")(d.created))+" · "+_vm._s(d.category))])],1)],1)],1),_vm._v(" "),(d.image)?_c('v-card-media',{attrs:{"src":'https://steemitimages.com/640x480/' + d.image,"height":"200px"}}):_vm._e(),_vm._v(" "),(!d.image)?_c('v-card-media',{attrs:{"src":"https://steemit.com/images/steemit.png","height":"200px"}}):_vm._e(),_vm._v(" "),_c('v-list',{attrs:{"three-line":""}},[_c('v-list-tile',{attrs:{"to":'/@' + d.author + '/' + d.permlink}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(d.title))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text-ellipsis"},[_vm._v(_vm._s(d.body))])],1)],1)],1),_vm._v(" "),_c('v-card-title',{staticClass:"pt-0"},[_c('router-link',{staticClass:"mr-1",attrs:{"to":'/@' + d.author + '/' + d.permlink + '/vote'}},[_vm._v("좋아요 "+_vm._s(d.net_votes)+"명")]),_vm._v(" · 댓글 "+_vm._s(d.children)+"명\n          "),_c('v-spacer'),_vm._v(" "),_c('strong',[_vm._v("$"+_vm._s(d.payout_value))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":""}},[_c('v-icon',{staticClass:"mr-2",attrs:{"left":"","dark":""}},[_vm._v("favorite_border")]),_vm._v(" 좋아요")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""}},[_c('v-icon',{staticClass:"mr-2",attrs:{"left":"","dark":""}},[_vm._v("comment")]),_vm._v(" 댓글달기")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""}},[_c('v-icon',{staticClass:"mr-2",attrs:{"left":"","dark":""}},[_vm._v("reply")]),_vm._v(" 공유하기")],1)],1)],1)],1)})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.next.exist),expression:"next.exist"}],staticClass:"text-xs-center mt-3 mb-1"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 682:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_steem__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_steem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_steem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Discussions__ = __webpack_require__(677);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Feed',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__Discussions__["a" /* default */]],
  // data () {
  //   return {}
  // }
  methods: {
    getDiscussions: function getDiscussions() {
      console.log('username', this.$route.params.username);
      var query = {
        tag: this.$route.params.username,
        limit: 11,
        start_permlink: this.next.permlink,
        start_author: this.next.author
        // 스팀잇 최근글 가져오기
      };return __WEBPACK_IMPORTED_MODULE_0_steem___default.a.api.getDiscussionsByFeedAsync(query);
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.e566e41f9c61572a6adc.js